export const MARKETPLACE_FREE_SHIPPING = 'pdp.marketplace_free_shipping';
export const MARKETPLACE_RESTRICTED_STATE = 'pdp.marketplace_restricted_state';
export const MARKETPLACE_MULTIPLE_RESTRICTED_STATES =
  'pdp.marketplace_multiple_restricted_states';
